import React from 'react';
import { FcClearFilters } from 'react-icons/fc';

export default function FilterBox({ items, textProperty, valueProperty, selectedItem, onItemSelect }) {
   if (items) {
      return (
         <div>
            <ul className='list-group custom font-weight-light text-muted'>
               {items.map((item, index) => (
                  <li
                     key={index}
                     className={valueProperty(item) === selectedItem(item) ? 'list-group-item d-flex justify-content-between active' : 'list-group-item d-flex justify-content-between'}
                     onClick={() => onItemSelect(item)}
                  >
                     {textProperty(item)}
                     {valueProperty(item) === '-1' ? (
                        <span>
                           {' '}
                           <FcClearFilters />
                        </span>
                     ) : (
                        <span className='badge badge-light'>{item.value.count}</span>
                     )}
                  </li>
               ))}
            </ul>
         </div>
      );
   } else {
      return (
         <ul classNam='list-group'>
            <li classNam='list-group-item active'>Cras justo odio</li>
            <li classNam='list-group-item'>Dapibus ac facilisis in</li>
            <li classNam='list-group-item'>Morbi leo risus</li>
            <li classNam='list-group-item'>Porta ac consectetur ac</li>
            <li classNam='list-group-item'>Vestibulum at eros</li>
         </ul>
      );
   }
}
